import React from "react";
import Typewriter from "typewriter-effect";
import pic from '../images/bg.png'
import '../App.css';

const Intro = () => {
  
  return (
    <>
      <div id='intro' className='section-padding'>
     <div className="h-screen">
     <div className="row">
      <div className="col-4 lg:col-4 m-9">
          <img src={pic} className="w-full ml-28 mt-36 sm:pl-2" alt="" />
        </div>
      <div className="col-6 sm:ml-12 mt-3 m-24 lg:mt-12 lg:m-16">
        <div className="text-center text-sm lg:text-3xl lg:mt-64 font-mono">
          Namaste world !!!
          <br />
          My name is <span className="underline font-mono font-extrabold">Aasia fatma</span>
          <div className="center">
            <Typewriter
 
                onInit={(typewriter) => {
                    typewriter
                        .typeString("A CSE undergraduate student")
                        .pauseFor(1000)
                        .deleteAll()
                        .typeString("Software developer")
                        .pauseFor(1000)
                        .deleteAll()
                        .typeString("Competitive programmer")
                        .start();

                }}
                loop
            />
        </div>
        </div>
        
      </div>
      </div>
     </div>
      
    </div>
    </>
  );
};

export default Intro;
